import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * GAListener — fires a GA4 `page_view` event on every route change AND on the
 * initial mount. Pairs with the gtag snippet in /public/index.html which sets
 * `send_page_view: false` so we own pageview dispatch and avoid double-counts.
 *
 * Works on every route, including hashed deep links, blog posts loaded via
 * the CMS, /states/ohio/:city pages, and /services/:slug accident pages.
 */
export default function GAListener({ measurementId = "G-ELS5JFKQV9" }) {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
      send_to: measurementId,
      page_path: pathname + search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [pathname, search, measurementId]);

  return null;
}
